import { useState, useEffect, useContext } from "react";
import "./TrainingDetailsPage.css";
import Sidebar from '../../webAppComponents/Sidebar/Sidebar';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import axios from 'axios';
import { SessionPageHeader } from '../SessionUC/SessionUC';
import TrainingsPageChanger from '../../webAppComponents/TrainingsPageChanger/TrainingsPageChanger';
import ExerciseDescription from '../../webAppComponents/ExerciseDescription/ExerciseDescription';

import RedTrash from "../../webAppAssets/red-trash.svg"
import ExportIcon from "../../webAppAssets/pdf-export.svg"
import EditPencil from "../../webAppAssets/edit-pencil.svg"
import RedExlcudeButton from "../../webAppAssets/red-x-in-circle.svg";
import ConfirmationPopup from '../../webAppComponents/ConfirmationPopup/Popup'
import ImportItemsPopup from "../../webAppComponents/ImportItemsPopup/ImportItemsPopup"
import { LuClock } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';
import createVirtualStage from "../../utils/VirtualStage";

const TrainingDetailsPage = () => {
    const { t, i18n } = useTranslation(["create-training-page", "session-page"]);

    const { state } = useLocation()
    const navigate = useNavigate()

    const [selectedExerciseIndex, setSelectedExerciseIndex] = useState(0);
    const [currentExerciseId, setCurrentExerciseId] = useState(null);
    const [trainingOptions, setTrainingOptions] = useState([]);
    const [sessionDeletePopup, setSessionDeletePopup ] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const [addExercisePopup, setAddExercisePopup] = useState(false)
    const [sessionData, setSessionData] = useState({
        session_number: state.dataLoaded ? state.dataLoaded.session_number : "",
        date: state.dataLoaded ? state.dataLoaded.date : "",
        microcycle: {
            cycle_number: state.dataLoaded ? state.dataLoaded.microcycle.cycle_number : "",
        },
        completed: state.dataLoaded ? state.dataLoaded.completed : "",
    });

    const [currentTraining, setCurrentTraining] = useState(null);

    const { authTokens } = useContext(AuthContext);

    const [stageData, setStageData] = useState([]);
    const [stageDataLoaded, setStageDataLoaded] = useState(false);
    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

    const [folders, setFolders] = useState([])
 

    // Define the headers with the Bearer token
    const headers = {
        Authorization: `Bearer ${authTokens.access}`,
    };

    const [trainings, setTrainings] = useState([]);
    const [selectedExercisesForPopup, setSelectedExercisesForPopup] = useState({
        training: []
    });

    const handleSelectedExerciseChange = (id) => {
      setCurrentExerciseId(id);
    };

    const getItems = () => {
        try {
            axios
                .get(process.env.REACT_APP_BACKEND + `training/session/${state.session}`, { headers })
                .then((response) => {
                  //console.log(response.data)
                  setCurrentTraining(response.data)
                  setCurrentExerciseId(response.data.exercises[0].id)
                  
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        } catch (error) {
            console.error(error)
        }
    }

    const getTrainingOptions = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND + 'training/exercise_options/list', { headers })
            setTrainingOptions(response.data)
        }
        catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        getItems()
        getTrainingOptions()
    }, [])


    const toStringFormat = (time) => {
      if (typeof time === "string")
        return time

      // from seconds to hh:mm:ss
      let hours = Math.floor(time / 3600);
      if (hours / 10 < 1)
        hours = `0${hours}`

      let minutes = Math.floor((time - (hours * 3600)) / 60);
      if (minutes / 10 < 1)
        minutes = `0${minutes}`

      let seconds = Math.floor(time - (hours * 3600) - (minutes * 60));
      if (seconds / 10 < 1)
        seconds = `0${seconds}`

      return (`${hours}:${minutes}:${seconds}`);
    }

    const calculateTotalDuration = (exercises) => {
        if (!exercises) return null;
        let totalDuration = 0;
        exercises.forEach(exercise => {
            // from hh:mm:ss to seconds
            const time_split = exercise.total_duration.split(":")
            totalDuration += (parseInt(time_split[0]) * 3600) + (parseInt(time_split[1]) * 60) + parseInt(time_split[2]);
        });

        return toStringFormat(totalDuration)
    }

    const handleDelete = () => {
      axios.delete(process.env.REACT_APP_BACKEND + `training/session/delete/${state.session}`, {headers})
        .then((response) => {
          navigate('/webapp/sessions')
        })
        .catch((error)=> {
          toast.error("delete-error")
        })
    }

    const toggleEditMode = () => {
      setEditMode(!editMode)
    }

    const toggleExercisesPopUp = () => {
      setAddExercisePopup(!addExercisePopup);
    }

  const handleSessionExerciseRemove = (id) => {
    axios.patch(process.env.REACT_APP_BACKEND + `training/session/exercises-update/${state.session}`, {"exercise" : id}, {headers})
      .then((response) => {
        const filtered_exercises = currentTraining.exercises.filter((exercise) => exercise.id != id)
        const deleted_exercise = currentTraining.exercises.find((exercise) => exercise.id == id)
        setCurrentTraining({
          ...currentTraining,
          exercises: filtered_exercises
        });
        setCurrentExerciseId(filtered_exercises[0].id)
        
        // reset image data for pdf if exercise is removed
        setStageData([])
        setStageDataLoaded(false)
      })
      .catch(() => {
        toast.error(t("delete-error"))
      })
  }

  const handleExerciseDataChange = (field, value) => {
    const exercises_modified =  currentTraining.exercises.map((exercise) => {
      if (exercise.id != currentExerciseId)
        return exercise

      if (field === "principles_of_play" && Array.isArray(exercise[field])) {
          const hasEqualValue = exercise[field].some((item) => item.id === value.id);
          if (hasEqualValue) {
              exercise = {
                  ...exercise,
                  [field]: exercise[field].filter((item) => item.id !== value.id),
              };
          } else {
              exercise = {
                  ...exercise,
                  [field]: [...exercise[field], value],
              };
          }
      }else{
        exercise = {
          ...exercise,
          [field]: value,
        };
      }

      exercise = {
        ...exercise,
        ["changed"]: true,
      };
      return exercise
    })

    setCurrentTraining({
      ...currentTraining,
      exercises: exercises_modified
    })
  };

  const handleSave = () => {
    if (!currentTraining.exercises.some((exercise) => exercise.changed === true)){
      toggleEditMode()
      return
    }

  
    axios.patch(process.env.REACT_APP_BACKEND + `training/session/update/${state.session}`, {currentTraining}, {headers})
      .then((response) => {
        location.reload();
      })
      .catch((error) => {
        console.error(error)
        toast.error(t("delete-error"))
      })
  }

  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [currentFolderData, setCurrentFolderData] = useState(null);

  useEffect(() => {
      if (addExercisePopup) {
          getTrainingPageItems();
      }
  }, [selectedFolderId, addExercisePopup]);

  const getTrainingPageItems = () => {
      if (selectedFolderId === null) {
          setCurrentFolderData(null)
          try {
              axios.get(process.env.REACT_APP_BACKEND + 'training/folder/list?parent_folder__isnull=True', { headers })
                  .then((response) => {
                      setFolders(response.data)
                  })
                  .catch((error) => {
                      console.error('Error:', error);
                  });
          }
          catch (error) {
              console.error(error);
          }
          try {
              axios.get(process.env.REACT_APP_BACKEND + 'training/exercise/list?folder__isnull=True&archive=False', { headers })
                  .then((response) => {
                      setTrainings(response.data)
                  })
                  .catch((error) => {
                      console.error('Error:', error);
                  })
          }
          catch (error) {
              console.log(error);
          }
      } else {
          // Get the current folder data
          try {
              axios.get(process.env.REACT_APP_BACKEND + 'training/folder/' + selectedFolderId, { headers })
                  .then((response) => {
                      setCurrentFolderData(response.data)
                  })
                  .catch((error) => {
                      console.error('Error:', error);
                  });
          }
          catch (error) {
              console.error(error);
          }
          // Get the folders inside
          try {
              axios.get(process.env.REACT_APP_BACKEND + 'training/folder/list?parent_folder=' + selectedFolderId, { headers })
                  .then((response) => {
                      setFolders(response.data)
                  })
                  .catch((error) => {
                      console.error('Error:', error);
                  });
          }
          catch (error) {
              console.error(error);
          }
          // Get the trainings inside
          try {
              axios.get(process.env.REACT_APP_BACKEND + 'training/exercise/list?folder=' + selectedFolderId + '&archive=False', { headers })
                  .then((response) => {
                      setTrainings(response.data)
                  })
                  .catch((error) => {
                      console.error('Error:', error);
                  })
          }
          catch (error) {
              console.error(error);
          }
      }
  }

  const handlePopupFolderSelection = (id) => {
      setSelectedFolderId(id)
  }

  const handlePopupTrainingChange = (training) => {
      const isSelected = selectedExercisesForPopup.training.find((t) => t.id === training.id);
      let newTrainingList;
      if (isSelected) {
          newTrainingList = selectedExercisesForPopup.training.filter((t) => t.id !== training.id);
      } else {
          newTrainingList = [...selectedExercisesForPopup.training, training];
      }
      setSelectedExercisesForPopup({
          ...selectedExercisesForPopup,
          training: newTrainingList
      });
  }

  const handleSaveAddedExercises = () => {
    if (selectedExercisesForPopup.training.length === 0) {
        toggleExercisesPopUp();
        return;
    }

    const exercise_ids = selectedExercisesForPopup.training.map(exercise => exercise.id);

    axios.patch(process.env.REACT_APP_BACKEND + `training/session/add-exercises/${state.session}`, {exercise_ids}, {headers})
        .then((response) => {
            toast.success(t("Saved"));
            window.location.reload();
        })
        .catch((error) => {
            console.error(error);
            toast.error(t("Error saving exercises"));
        });
  }

  const handleAddExercise = (exercise_id) => {
    axios.patch(process.env.REACT_APP_BACKEND + `training/session/add-exercise/${state.session}`, {exercise_id}, {headers})
      .then((response) => {
        toast.success("saved")
        location.reload();
      })
      .catch((error) => {
        console.error(error)
        toast.error(t("delete-error"))
      })
  }

  const getStageData = async (exercises) => {
    const stages = await Promise.all(
      exercises.map(async (exercise) => {
        let stage = null;
        try {
          stage = await createVirtualStage(exercise.drawing);
          const dataURL = await stage.toDataURL({ pixelRatio: 1 });
          const isVertical = stage.width() < stage.height();
          return {
            image: dataURL,
            isVertical: isVertical
          };
        } 
        catch (error) {
          console.error("Error generating stage data for exercise:", exercise.id, error);
          return {
            image: '',
            isVertical: false
          };
        }
        finally {
          if (stage != null) {
            stage.destroy();
          }
        }
    }));
    
    return stages;
  };

  const generatePDF = (stage_data) => {
    axios.post(process.env.REACT_APP_BACKEND + `training/session/pdf/${state.session}`, 
      {
        session_number: sessionData.session_number,
        microcycle_number: sessionData.microcycle.cycle_number,
        language: i18n.language,
        exercise_ids: currentTraining?.exercises.map(exercise => exercise.id),
        image_data: stage_data.map(stage => stage.image),
        is_vertical: stage_data.map(stage => stage.isVertical)
      },
      {headers, responseType: 'blob'}
    )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `session_${sessionData.session_number}_mc_${sessionData.microcycle.cycle_number}_${sessionData.date}.pdf`
        );

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setIsGeneratingPDF(false);
      })
      .catch((error) => {
        console.error(error)
        toast.error(t("pdf-error", { ns: "session-page" }));
        setIsGeneratingPDF(false);
      });
  }

  const handleDownloadPDF = async () => {
    if (isGeneratingPDF) return;
    setIsGeneratingPDF(true);
    
    if (!stageDataLoaded) {
      try {
        const data = await getStageData(currentTraining.exercises);
        setStageData(data);
        setStageDataLoaded(true);

        if (data.length === 0) {
          toast.error(t("pdf-error", { ns: "session-page" }));
          setIsGeneratingPDF(false);
          return;
        }

        generatePDF(data);
      } 
      catch (error) {
        console.error("Error generating stage data:", error);
        toast.error(t("pdf-error", { ns: "session-page" }));
        setIsGeneratingPDF(false);
      }

      return;
    }

    if (stageData.length === 0) {
      toast.error(t("pdf-error", { ns: "session-page" }));
      setIsGeneratingPDF(false);
      return;
    }

    generatePDF(stageData);
  }

    return (
        <div className="webapp-sessioninfo">
            <Sidebar selectedOption="trainings" />
            <div className="webapp-sessioninfo-content">
                <SessionPageHeader sessionData={sessionData} />
                <div className="webapp-session-trainings-header">
                    <div>
                        <TrainingsPageChanger
                            selectedPage={0}
                            pages={[
                                { label: t('Training details', { ns: "session-page" }), path: '/webapp/session/trainings', state: { "session": state.session, "training": sessionData?.training?.id } },
                                { label: t('Load Unit', { ns: "session-page" }), path: '/webapp/SessionUC', state: { "session": state.session, "dataLoaded": sessionData } },
                                { label: t('Forms', { ns: "session-page" }), path: '/webapp/session/forms', state: { "session": state.session, "dataLoaded": sessionData } },
                                { label: t('Players', { ns: "session-page" }), path: '/webapp/SessionEditPlayers', state: { "session": state.session, "dataLoaded": sessionData } },
                            ]}
                        />
                    </div>
                    <div className='webapp-session-trainings-header-items'>
                        <div className="session-trainings-header-titles-container">
                            <h2 className="session-trainings-header-titles ">{t('Total Duration')}</h2>
                        </div>
                        <div className="session-trainings-header-info-container">
                            <div className="session-training-total-duration"> <span className="black-16px-600"><LuClock /> {calculateTotalDuration(currentTraining?.exercises)}</span></div>
                            <div className="session-training-edit-holder">
                            {editMode ?
                              <div className="session-training-edit-holder">
                                <button className="webapp-createteam-button webapp-createteam-white-button webapp-createteam-edit webapp-session-players-edit" onClick={handleSave}>
                                  <img src={EditPencil} alt="Edit Button" />{t('Save', { ns: "session-page" })}
                                </button>
                                <button className="webapp-createteam-button webapp-createteam-white-button webapp-createteam-edit webapp-session-players-edit" onClick={toggleExercisesPopUp}>
                                  {'+ ' + t('Exercise')}
                                  </button>
                              </div >
                              :
                              <div className="session-training-edit-holder">
                                <button className="webapp-createteam-button webapp-createteam-white-button webapp-createteam-edit webapp-session-players-edit" onClick={handleDownloadPDF}>
                                  <img src={ExportIcon} alt="PDF Button" />{isGeneratingPDF ? t('Generating PDF', { ns: "session-page" }) + "..." : t('Download PDF', { ns: "session-page" })}
                                </button>
                                <button className="webapp-createteam-button webapp-createteam-white-button webapp-createteam-edit webapp-session-players-edit" onClick={toggleEditMode}>
                                  <img src={EditPencil} alt="Edit Button" />{t('Edit')}
                                </button>
                              </div>
                            }
                              <div className='webapp-injury-delete-button' onClick={() => setSessionDeletePopup(true)}>
                                  <img src={RedTrash} /> <span>{t('delete-session')}</span>
                              </div>
                            </div >
                        </div>
                    </div>
                    <div className="webapp-session-training-exercises-container">
                        <h1> {t('Exercises')} </h1>
                        {sessionDeletePopup ? (<ConfirmationPopup data={{ image: "close", message: [t('delete-session-message'), ""], close: t('Cancel'), advance: t('Delete') }} setState={setSessionDeletePopup} action={handleDelete} />) : null}
                        {addExercisePopup && 
                          <ImportItemsPopup 
                            trainings={trainings} 
                            currentFolder={currentFolderData} 
                            folders={folders} 
                            handleChange={handlePopupTrainingChange} 
                            handleFolderSelection={handlePopupFolderSelection} 
                            session={selectedExercisesForPopup}
                            togglePopup={toggleExercisesPopUp}
                            handleSave={handleSaveAddedExercises}
                          />
                        }
                        <div className="webapp-session-training-exercise-content">
                            <div className="webapp-session-players-exercises">
                                {currentTraining?.exercises.slice() // Clone the array to avoid mutating the original order
                                  .map((exercise) => (
                                    <div key={exercise.id} className={`webapp-session-players-exercise ${currentExerciseId === exercise.id ? 'exercise-selected' : ''}`} onClick={() => handleSelectedExerciseChange(exercise.id)}>
                                        <span className="black-16px-600" >{exercise.name}</span>
                                        {currentTraining?.exercises.length > 1 &&
                                            <button onClick={() => handleSessionExerciseRemove(exercise.id)} className={`webapp-session-players-player-delete ${editMode  ? '' : 'nondisplay'}`}> <img src={RedExlcudeButton} alt="Button to delete player" /> </button>
                                        }
                                    </div>
                                ))}
                            </div>
                            {currentExerciseId && (
                              <ExerciseDescription
                                exercise={currentTraining.exercises.find(exercise => exercise.id === currentExerciseId)}
                                trainingOptions={trainingOptions}
                                editMode={editMode}
                                handleExerciseDataChange={handleExerciseDataChange}
                              />
                              )}
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )

}

export default TrainingDetailsPage
